import React, { useEffect, useState } from 'react';
import Tab from 'react-bootstrap/Tab';
import './tabs.css';
import CustomTabListView from '../CustomTabListView';
import { tabsData } from './tabsData';

const TabsComponent = (props: any) => {
  const { tabs = [] } = props;

  return (
    <div className="user-management">
      <CustomTabListView {...props} id={'user-management-tabs'}>
        {tabs.map((list: string) => {
          return (
            <Tab key={list} eventKey={list} title={list}>
              { <div>{tabsData?.[list]}</div>}
            </Tab>
          );
        })}
      </CustomTabListView>
    </div>
  );
};
export default TabsComponent;
